import { UserDocument } from '../lib/userDocuments.slice'
import { UploadRequiredDocumentButton } from '../shared/UploadRequiredDocumentButton'
import { UserDocumentActionButton } from '../shared/UserDocumentActionButton'

import { Table } from '@/ui'

interface ActionCellProps {
  document: UserDocument
}

// TODO: Migrate to V2 for delete dialog skipcq: JS-0099
// Keep with V1 Delete Modal until we migrate to V2. New version will use DialogTrigger.
export const ActionCell = ({ document }: ActionCellProps) => {
  return (
    <Table.Cell className="flex justify-center overflow-visible">
      {/* Required, missing documents have their id set to -1 */}
      {document.id === -1 && (
        <UploadRequiredDocumentButton document={document} />
      )}
      {document.id !== -1 && <UserDocumentActionButton document={document} />}
    </Table.Cell>
  )
}
